var borders_default = {
  "borderT": "AX-JT",
  "borderB": "ZHAtX",
  "borderL": "Pe4-f",
  "borderR": "JNxjw"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
